import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFork: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFork"><Path d="M7.40725 2H5.54688L4.5 15.4054L8.26636 19.4245V22H15.7336V19.4245L19.5 15.4054L18.4531 2L16.5928 2.00001V12.0793C16.5928 12.6075 16.1915 13.0357 15.6965 13.0357C15.2015 13.0357 14.8002 12.6075 14.8002 12.0793V2H12.9334V12.0396C12.9334 12.5897 12.5155 13.0357 12 13.0357C11.4845 13.0357 11.0666 12.5897 11.0666 12.0396V2H9.19977V12.0793C9.19977 12.6075 8.7985 13.0357 8.30351 13.0357C7.80852 13.0357 7.40725 12.6075 7.40725 12.0793V2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFork;
